import { render, staticRenderFns } from "./SetIcon.vue?vue&type=template&id=0250a232&functional=true&"
import script from "./SetIcon.vue?vue&type=script&lang=js&"
export * from "./SetIcon.vue?vue&type=script&lang=js&"
import style0 from "./SetIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports